/**
 * Created by jiang on 2018/11/1.
 */
// 地址加代理端口（访问地址的端口,在ng上面做映射到服务地址）
// const BASE_URL = 'http://www.kdslow.com'
// const BIZ = '/biz'
const Api = {
  // 市场部 后台
  // Market_BASE_URL: 'http://ad.kdslow.com/api',
  // Market_BASE_URL: 'http://www.kdslow.com',
  Market_BASE_URL: '/adapi',
  // 获取团队列表
  getTeamList: '/gw/team/page',

  // 获取学校列表
  getSchoolList: '/gw/teamschool/page',

  // 新增意向合伙人
  // eslint-disable-next-line camelcase
  addConnect: '/gw/connect/add',

  // 获取标语
  getInfo: '/gw/info',

  // 获取标语
  getNewsPage: '/gw/news/page',

  // 获取资源列表
  getResList: '/gw/resFile/page',

  changeClass: 0

}

module.exports = Api



// WEBPACK FOOTER //
// ./src/assets/js/Api.js